import React from "react";
import { EMPTY_VALUE_PLACEHOLDER } from "@sscs/utils";
const ValueOrPlaceholder = ({ value, placeholder = EMPTY_VALUE_PLACEHOLDER, }) => {
    return React.createElement(React.Fragment, null, value ? value.toLocaleString() : placeholder);
};
export default ValueOrPlaceholder;
//# sourceMappingURL=ValueOrPlaceholder.js.map